import {lazy, useEffect} from "react";
import {useLocation} from "react-router-dom-v5-compat";

import {isKhanAcademyUrl, isRelativeUrl, redirect} from "@khan/urls";

import FullPageSpinner from "./full-page-spinner.tsx";

const NotFound = lazy(() => import("./not-found.tsx"));

export default function ContinueRedirect() {
    const {search} = useLocation();
    const continueUrl = new URLSearchParams(search).get("continue");

    useEffect(() => {
        if (
            continueUrl &&
            (isRelativeUrl(continueUrl) || isKhanAcademyUrl(continueUrl))
        ) {
            redirect(continueUrl);
        }
    }, [continueUrl]);

    return continueUrl ? <FullPageSpinner /> : <NotFound />;
}
